import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // Handle responsive sidebar
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setSidebarCollapsed(true);
      }
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-1831">
      <Sidebar collapsed={sidebarCollapsed} data-id="element-1832" />
      {/* Overlay for mobile sidebar */}
      {isMobile && !sidebarCollapsed && <div className="fixed inset-0 bg-black bg-opacity-50 z-10" onClick={toggleSidebar} data-id="element-1833"></div>}
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1834">
        <Header onMenuClick={toggleSidebar} data-id="element-1835" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-gray-50 transition-all duration-200" data-id="element-1836">
          <div className="container mx-auto max-w-7xl" data-id="element-1837">{children}</div>
        </main>
      </div>
    </div>;
}